import { TransWithDefault } from '@starsoft/common/components';
import styles from '../styles.module.scss';
import { useTranslation } from '@starsoft/common/hooks';
import { RollCompetitionContentHeaderProps } from './props';
import RollCompetitionContentHeaderSkeleton from './Skeleton';
import { useRollCompetitions } from '@/api/roll-competitions';

export default function RollCompetitionContentHeader({
  isLoading,
}: RollCompetitionContentHeaderProps) {
  const { t } = useTranslation('common');
  const { rollCompetition } = useRollCompetitions();

  if (isLoading) {
    return <RollCompetitionContentHeaderSkeleton />;
  }

  return (
    <>
      <h2 className={styles.container__title}>
        <TransWithDefault
          i18nKey="common:roll_point_game_heading"
          values={{
            level: t('every_cycle'),
          }}
        />
      </h2>
      <p className={styles.container__description}>
        <TransWithDefault
          i18nKey="common:roll_point_game_description"
          values={{
            durationInHours: rollCompetition?.durationInHours,
          }}
        />
      </p>
    </>
  );
}
